import * as z from "zod/v4";

const AeoPromptSchema_ = z.object({
  id: z.string(),
  prompt: z.string(),
  category: z.string(),
  createdAt: z.string(),
});

export const AeoPromptSchema: z.ZodType<AeoPromptSchema> = AeoPromptSchema_;
export interface AeoPromptSchema extends z.infer<typeof AeoPromptSchema_> {}

export const getAeoPrompts = {
  name: "getAeoPrompts" as const,
  input: z.object({}),
  output: z.array(AeoPromptSchema),
};
